import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-P",
  "use": "icon-P-usage",
  "viewBox": "0 0 60 60",
  "content": "<symbol viewBox=\"0 0 60 60\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-P\">\n<path d=\"M31.5606 23.128L48.6966 40.216C49.3686 40.936 50.4726 40.936 51.1446 40.216C51.4806 39.88 51.6246 39.448 51.6246 39.016C51.6246 38.584 51.4806 38.104 51.1446 37.768L34.0086 20.632C31.8486 18.472 28.2966 18.472 26.1366 20.632L8.85656 37.96C8.18456 38.632 8.18456 39.736 8.85656 40.408C9.52856 41.08 10.6326 41.08 11.3046 40.408L28.5846 23.128C29.4006 22.312 30.7446 22.312 31.5606 23.128Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol